<template>
    <div class="listing-hours-edit">
        <status-message></status-message>
        <div class="td-banner info no-icon border mb-4" v-if="!singleEdit">
            <p>
                Create an hours of operation template and apply the settings to the listing types specified.
                Hours of operation times entered are always displayed in <strong>the local timezone of the listing</strong>.
            </p>
            <p class="td-text-orange">
                <strong>Caution:</strong> Changes that are applied using this form will override existing hours of operations for the listings specified.
            </p>
            <div class="td-form mt-2 td-flex location-selection">
                <div>
                    <label class="td-label" for="listings-option">Apply edits to:</label>
                    <select v-model="listingsOption" class="td-select" id="listings-option" @change="updateListingsOption">
                        <option value="all">All Listings</option>
                        <option value="region">All Listings in Region</option>
                        <option value="single">Single Listing</option>
                    </select>
                </div>
                <div v-if="listingsOption === 'single'">
                    <listing-lookup :account-id="accountId"
                                    :listing-id="listingId"
                                    :is-error="false"
                                    @select-listing="selectListing">
                    </listing-lookup>
                </div>
                <div v-if="listingsOption === 'region'">
                    <label class="td-label" for="region-option">Select State/Province:</label>
                    <select v-model="selectedRegion" class="td-select" id="region-option" @change="updateListingsOption">
                        <option v-for="region in availableRegions" :value="region">{{region}}</option>
                    </select>
                </div>

            </div>
        </div>
        <div v-if="errorMessage" class="td-banner danger error icon-left">
            <icon name="faExclamation" type="solid"></icon>
            <p>{{errorMessage}}</p>
        </div>
        <hours-settings :hours-type="model.type" :holiday-condition="model.majorHolidaysCondition" @update-model="updateModel"></hours-settings>
        <div class="td-text-right mt-2">
            <button class="td-btn secondary" @click="saveHours($event)">Save Hours Settings</button>
        </div>
        <div v-if="model.type == HoursOfOperationType.AlwaysOpen" class="td-banner success my-3">
            <icon name="faClock" type="solid"></icon>
            <p>Selected locations are open 24/7.</p>
        </div>
        <hours-table-navigation @update-navigation="updateNavigation" :hours-type="model.type" :add-exception="showAddException" :table-tab="tab"></hours-table-navigation>
        <weekly-schedule v-if="tab == HoursTab.Hours &&  model.type == HoursOfOperationType.SelectHours" :hours-type="afterHoursType" :entries="allEntries" @update-entries="updateEntries"></weekly-schedule>
        <hours-exceptions v-if="tab == HoursTab.Exceptions" :exceptions="exceptionsModel.exceptions" :location-ids="exceptionsModel.locationIds"
                          :add-exception="showAddException" @cancel-update="cancelUpdate" @update-exceptions="updateExceptions" ref="exceptionsRef"></hours-exceptions>
        <holiday-hours v-if="tab == HoursTab.HolidayHours" :holidays="holidaysModel.holidays" @update-holidays="updateHolidays" :condition="model.majorHolidaysCondition" :country-code="countryCode"></holiday-hours>
        <div class="td-text-right" v-if="tab == HoursTab.Hours">
            <button class="td-btn secondary mt-4" @click.prevent="saveHours($event)">Save Hours</button>
        </div>
        <div class="td-text-right"v-if="tab == HoursTab.Exceptions">
            <button class="td-btn secondary mt-4" @click.prevent="saveExceptions($event)">Save Exceptions</button>
        </div>
        <div class="td-text-right" v-if="tab == HoursTab.HolidayHours">
            <button class="td-btn secondary mt-4" @click.prevent="saveHolidays($event)">Save Holidays</button>
        </div>
    </div>
   
</template>
<script>
import script from './BulkHoursEdit';
    export default script;</script>

<style lang="less">
    @import "./BulkHoursEdit.less";
</style>